import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '../../../Global/Modals/DialogForm';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Formik, Field } from 'formik';
import ProgressButton from '../../../Global/Buttons/Progress';
import classnames from 'classnames';
import ButtonStyles from '../../../../styles/button';
import SpacingStyles from '../../../../styles/helpers/spacing';
import combineStyles from '../../../../utils/combineStyles';
import DateFieldInput from '../../../Global/Inputs/DateField';
import TimeFieldInput from '../../../Global/Inputs/TimeField';
import CheckboxInput from '../../../Global/Inputs/Checkbox';
import validationSchema from './ActualDateForm.schema';
import moment from 'moment';
import _get from 'lodash/get';
import _set from 'lodash/set';

const styles = theme => ({
  forgiveLateness: {
    marginTop: theme.spacing.unit * 2
  },
  form: { marginTop: theme.spacing.unit * 0.5 }
});
export class ActualDateFormModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    title: PropTypes.PropTypes.string.isRequired,
    type: PropTypes.oneOf(['Pickup', 'Delivery']),
    stop: PropTypes.shape({
      actualDate: PropTypes.string,
      actualTime: PropTypes.number,
      carrierWasLate: PropTypes.bool
    })
  };
  state = { isSubmitting: false, formSchema: {} };

  _handleCancel = resetForm => {
    const { onClose } = this.props;
    resetForm();
    onClose();
  };
  _handleValidateField = async (
    currentField,
    currentValue,
    values,
    setFieldError
  ) => {
    const { formSchema } = this.state;
    const valueCopy = { ...values };
    const updatedValues = _set(valueCopy, currentField, currentValue);

    try {
      await formSchema.validateAt(currentField, updatedValues);
      setFieldError(currentField, null);
    } catch (err) {
      setFieldError(currentField, err.message);
    }
  };
  componentDidMount() {
    const { t } = this.props;
    const formSchema = validationSchema({ t });
    this.setState({ formSchema });
  }
  render() {
    const { open, onClose, t, classes, onSave, title, type, stop } = this.props;
    const { isSubmitting, formSchema } = this.state;

    return (
      <Formik
        handleSubmit={this._handleOnSave}
        enableReinitialize={false}
        validationSchema={formSchema}
        validateOnBlur={true}
        validateOnChange={false}
        initialValues={{
          actualDate: _get(stop, 'actualDate', moment().format('MMM DD, YYYY')),
          actualTime: _get(stop, 'actualTime', null),
          carrierWasLate: stop.carrierWasLate,
          forgiveLate: false
        }}
        onSubmit={async (values, actions) => {
          this.setState({ isSubmitting: true });
          const savedSuccessfully = await onSave(type, values);
          if (savedSuccessfully) {
            actions.resetForm();
            onClose();
          }
        }}
        render={({
          values,
          handleChange,
          handleSubmit,
          handleReset,
          setFieldError
        }) => (
          <DialogForm
            open={open}
            title={title}
            onClose={onClose}
            footer={
              <Fragment>
                <div className={classes.spacer} />
                <Button
                  className={classes.button}
                  onClick={() => {
                    this._handleCancel(handleReset);
                  }}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
                <ProgressButton
                  color="primary"
                  className={classnames(classes.button)}
                  classes={{
                    disabled: classes.buttonDisabled,
                    label: classnames(classes.buttonLabel)
                  }}
                  onClick={handleSubmit}
                  isSubmitting={isSubmitting}
                >
                  {t('Submit')}
                </ProgressButton>
              </Fragment>
            }
          >
            <Grid container spacing={16} classes={{ container: classes.form }}>
              <Grid item lg={6}>
                <Field
                  name={'actualDate'}
                  onChange={handleChange}
                  render={({ field, form }) => (
                    <DateFieldInput
                      value={values.actualDate}
                      field={field}
                      form={form}
                      disablePast={false}
                      label={`${t('Actual')} ${t(type)} ${t('Date')}`}
                      format={'MMM DD, YYYY'}
                      savingFormat={'MMM DD, YYYY'}
                      validateField={(currentField, currentValue) => {
                        this._handleValidateField(
                          currentField,
                          currentValue,
                          values,
                          setFieldError
                        );
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item lg={6}>
                <Field
                  name={'actualTime'}
                  onChange={handleChange}
                  render={({ field, form }) => {
                    return (
                      <TimeFieldInput
                        value={values.actualTime}
                        field={field}
                        form={form}
                        label={`${t('Actual')} ${t(type)} ${t('Time')}`}
                        validateField={(currentField, currentValue) => {
                          this._handleValidateField(
                            currentField,
                            currentValue,
                            values,
                            setFieldError
                          );
                        }}
                      />
                    );
                  }}
                />
              </Grid>
              <Grid item lg={12}>
                <Field
                  name={'carrierWasLate'}
                  onChange={handleChange}
                  render={({ field, form }) => (
                    <CheckboxInput
                      label={t('Late')}
                      field={field}
                      form={form}
                      value={values.carrierWasLate}
                      disabled={values.forgiveLate}
                      classes={{
                        root: classnames(classes.noMarginTop)
                      }}
                    />
                  )}
                />
                <div className={classes.forgiveLateness}>
                  <Field
                    name={'forgiveLate'}
                    onChange={handleChange}
                    render={({ field, form }) => (
                      <CheckboxInput
                        label={t('Forgive Lateness')}
                        field={field}
                        form={form}
                        value={values.forgiveLate}
                        disabled={values.carrierWasLate}
                        classes={{
                          root: classnames(classes.noMarginTop)
                        }}
                      />
                    )}
                  />
                </div>
              </Grid>
            </Grid>
          </DialogForm>
        )}
      />
    );
  }
}
const translatedActualDateFormModal = withNamespaces()(ActualDateFormModal);
export default withStyles(combineStyles(styles, SpacingStyles, ButtonStyles))(
  translatedActualDateFormModal
);
